import React from 'react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';
import { Music2, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${heroData.backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black"></div>
      </div>

      {/* Floating Music Notes Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <Music2 className="absolute top-20 left-10 text-amber-500/20 animate-float" size={40} style={{ animationDelay: '0s' }} />
        <Music2 className="absolute top-40 right-20 text-amber-500/20 animate-float" size={30} style={{ animationDelay: '1s' }} />
        <Sparkles className="absolute bottom-40 left-20 text-amber-400/20 animate-float" size={35} style={{ animationDelay: '2s' }} />
        <Music2 className="absolute bottom-20 right-10 text-amber-500/20 animate-float" size={45} style={{ animationDelay: '1.5s' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        {/* Logo Large */}
        <div className="mb-8 animate-fade-in">
          <img 
            src="/logo-masterclass.png" 
            alt="Master Class" 
            className="h-32 sm:h-40 w-auto mx-auto object-contain drop-shadow-2xl"
          />
        </div>

        {/* Subtitle */}
        <div className="mb-6 animate-fade-in" style={{ animationDelay: '0.2s' }}>
          <span className="inline-block px-6 py-2 bg-amber-500/20 border border-amber-500/30 rounded-full text-amber-400 font-semibold text-sm tracking-wider backdrop-blur-sm">
            {heroData.subtitle}
          </span>
        </div>

        {/* Description */}
        <p 
          className="text-xl sm:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed animate-fade-in"
          style={{ animationDelay: '0.4s' }}
        >
          {heroData.description}
        </p>

        {/* CTA Buttons */}
        <div 
          className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in"
          style={{ animationDelay: '0.6s' }}
        >
          <Button 
            size="lg"
            onClick={scrollToContact}
            className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-bold text-lg px-8 py-6 shadow-2xl shadow-amber-500/50 transition-all duration-300 hover:scale-105 hover:shadow-amber-500/70"
          >
            {heroData.ctaText}
          </Button>
          <Button 
            size="lg"
            variant="outline"
            onClick={() => document.getElementById('asignaturas').scrollIntoView({ behavior: 'smooth' })}
            className="border-2 border-gray-500 text-gray-300 hover:bg-gray-800 hover:text-white hover:border-amber-500 font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
          >
            Ver Asignaturas
          </Button>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto animate-fade-in" style={{ animationDelay: '0.8s' }}>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-400 mb-2">7+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wide">Años</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-400 mb-2">6</div>
            <div className="text-sm text-gray-400 uppercase tracking-wide">Asignaturas</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-400 mb-2">150+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wide">Alumnos</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-400 mb-2">6</div>
            <div className="text-sm text-gray-400 uppercase tracking-wide">Profesores</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-amber-500/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-amber-500 rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
